<script setup>
import { computed } from 'vue';
import { useStore } from 'dashboard/composables/store.js';

const store = useStore();
const account = computed(() => store.getters.getCurrentAccount);

/**
 * Embed da Central de Ajuda da SiteUp dentro do dashboard via iframe.
 *
 * - URL externa: https://ajuda.siteup.com.br?embed=1
 * - O parametro `?embed=1` faz a Central esconder seu proprio header/footer
 *   pra nao duplicar o frame do dashboard
 * - Cookie `siteup_embed` eh setado pelo middleware do siteup-site na
 *   primeira request, persistindo o modo embed entre navegacoes do iframe
 *
 * Ajustes futuros possiveis:
 * - Passar `?account_id=X` pra Central exibir info contextual da conta
 * - Sincronizar tema light/dark via postMessage
 * - Ouvir cliques em "Falar com a gente" pra abrir conversa direto no Chatwoot
 */
const helpCenterUrl = computed(() => {
  const baseUrl = 'https://ajuda.siteup.com.br';
  const params = new URLSearchParams({ embed: '1' });
  if (account.value?.id) {
    params.set('account_id', String(account.value.id));
  }
  return `${baseUrl}?${params.toString()}`;
});
</script>

<template>
  <div class="flex flex-col h-full w-full bg-n-background">
    <iframe
      :src="helpCenterUrl"
      class="flex-1 w-full border-0"
      title="Central de Ajuda SiteUp"
      allow="clipboard-write; clipboard-read"
      referrerpolicy="strict-origin-when-cross-origin"
      loading="eager"
    />
  </div>
</template>
